<template>

    <table class="table" :class="classname.join(' ')">
        <thead>
            <slot name="thead"></slot>
        </thead>
        <tbody>
            <slot name="tbody"></slot>
        </tbody>
    </table>

</template>

<script>

    export default{
        name: 'TableElement',
        props:{
            classname:{
                type: Array,
                required: true
            }

        }

    }

</script>